(() => {
  function initHero(root) {
    const slides = Array.from(root.querySelectorAll('[data-cm-hero-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-cm-hero-dot]'));
    if (slides.length < 2) return;

    let index = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains('is-active'))
    );
    let timer;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    };

    const play = () => {
      stop();
      const speed = Number(root.dataset.autoplay || 6000);
      timer = window.setInterval(() => show(index + 1), speed);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = undefined;
    };

    root.querySelector('[data-cm-hero-prev]')?.addEventListener('click', () => {
      show(index - 1);
      play();
    });
    root.querySelector('[data-cm-hero-next]')?.addEventListener('click', () => {
      show(index + 1);
      play();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.cmHeroDot || 0));
        play();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    show(index);
    play();
  }

  const start = () => {
    document.querySelectorAll('[data-cm-hero]').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
